import { use } from 'react'
import { ToastContext } from './ToastContext'

export const useToast = () => {
  return use(ToastContext)
}
